import { h } from '../lib/dom';
import { createBrandGlyph } from './atom';

export function renderNav(): HTMLElement {
  const wordmark = h('span', { class: 'wordmark' },
    h('span', { class: 's1' }, 'fun'),
    h('span', { class: 's2' }, 'sou'),
    h('span', { class: 's3' }, 'rce'),
  );

  const brand = h('a', { href: '#', class: 'nav-brand', 'aria-label': 'FunSource home' },
    createBrandGlyph(28),
    wordmark,
  );

  return h('header', { class: 'nav' },
    h('div', { class: 'container nav-inner' }, brand),
  );
}
